import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment SignUp_getMyCampaigns on Campaign {
      secondaryCallToAction {
        id
        type
        data
      }
    }
  `,
};
